module.exports = __webpack_public_path__ + "img/OSINT Social Media.300a37e6.png";